import React from 'react';
import { Heart } from 'lucide-react';
import { ourStory } from '../data/mock';
import { useLanguage } from '../LanguageContext';

export const OurStory = () => {
  const { t } = useLanguage();
  
  return (
    <section id="our-story" className="our-story-section">
      <div className="container">
        <div className="section-header">
          <Heart className="section-icon" />
          <h2 className="section-title">{t('story.title')}</h2>
          <div className="decorative-line-small"></div>
        </div>

        <div className="story-content">
          <p className="story-text">{t('story.content')}</p>
        </div>

        {ourStory.timeline && ourStory.timeline.length > 0 && (
          <div className="timeline">
            {ourStory.timeline.map((event, index) => (
              <div key={index} className="timeline-item" data-aos="fade-up">
                <div className="timeline-marker">
                  <div className="timeline-dot"></div>
                  {index < ourStory.timeline.length - 1 && <div className="timeline-line"></div>}
                </div>
                <div className="timeline-content">
                  <div className="timeline-year">{event.year}</div>
                  <h3 className="timeline-title">{event.title}</h3>
                  <p className="timeline-description">{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default OurStory;
